import router, { resetRouter } from '@/router/index'
import url from "@/api/url.js"
import {
  post,
  get
} from "@/api/http.js";

const state = {
  // id: '1',
  // headPortrait: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201503%2F03%2F20150303104600_PmTmE.jpeg&refer=http%3A%2F%2Fb-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1632931548&t=bd330b002c2d4a423b73508cda1df1d9',
  // isCharge: '',
  // password: '',
  // phone: 'AatPd2NOIzL+m8fbabJS3w==',
  // schoolId: 1,
  // schoolName: '广州市长兴中学',
  // teacherName: '李小松',
  // teacherNumber: 'HS1001',
  // entryDate: "2021-08-31",
  // title: '班主任',
  // token: '',
  // roleId: '2',
  // resume: '',

  id: '',
  headPortrait: '',
  // isCharge: '',
  // password: '',
  phone: '',
  schoolId: '',
  schoolName: '',
  teacherName: '',
  teacherNumber: '',
  studentNumber: '',
  studentName: '',
  jobList: [],
  entryDate: '',
  // title: '',
  token: '',
  // roleId: '',
  resume: '',
  classDataPerm: '',
  accessToken: '',
  refreshToken: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  // SET_ROLEID: (state, roleId) => {
  //   state.roleId = roleId
  // },
  SET_USER: (state, data) => {
    // console.log(data)
    // state = data
    for (let k in state) {
      state[k] = data[k]
    }
    // console.log("user", state)
  },
  SET_HEADPORTRAIT: (state, headPortrait) => {
    // console.log(headPortrait)
    state.headPortrait = headPortrait
  },
}

const actions = {
  // setUser({ commit, state }, data) {
  //   commit('SET_USER', data)
  // },
  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // 调用获取用户信息接口
      get(url.getTeacherByToken, {
        // token: window.localStorage.getItem('bbfAdminTeacherToken')
        // id: window.localStorage.getItem('tid')
      }).then(res => {
        console.log("获取用户信息==>", res)
        const { data } = res
        if (!data) {
          reject('验证失败，请重新登录！')
        }

        // const roleId = 1

        // // roleId不能为空
        // if (!roleId) {
        //   reject('getInfo: roleId不能为空')
        // }

        commit('SET_USER', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除 token
  resetToken({ commit }) {
    return new Promise(resolve => {
      // 清空store的token和roleId
      commit('SET_TOKEN', '')
      // commit('SET_ROLEID', '')
      // 删除缓存中的token
      // storage.remove('bbfAdminTeacherToken')
      window.localStorage.removeItem('bbfAdminTeacherToken')
      window.localStorage.removeItem('local_userInfo')
      window.localStorage.removeItem('tid')
      // 重置路由
      resetRouter()
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
